<mat-progress-bar *ngIf="loading && !picture" mode="indeterminate"></mat-progress-bar>
<p *ngIf="refreshing" class="refresh-hint">Refreshing role data…</p>

<ng-container *ngIf="picture as role">
  <mat-card class="overview-card">
    <header class="overview-header">
      <div>
        <h1>{{ role.name }}</h1>
        <p>{{ role.summary }}</p>
        <mat-chip-set>
          <mat-chip>Slug: {{ slug }}</mat-chip>
          <mat-chip>Status: {{ statusLabel() }}</mat-chip>
        </mat-chip-set>
      </div>
      <div class="actions">
        <button mat-stroked-button type="button" (click)="reload(true)" [disabled]="isBusy">Reload</button>
        <button mat-flat-button type="button" [matMenuTriggerFor]="actionMenu" [disabled]="isBusy">
          Actions
        </button>
        <mat-menu #actionMenu="matMenu">
          <button mat-menu-item type="button" (click)="setActivation(!isEngaged())">
            {{ isEngaged() ? 'Deactivate' : 'Activate' }}
          </button>
          <button
            mat-menu-item
            type="button"
            *ngIf="isEngaged() && !role.active"
            (click)="setActivation(true, true)">
            Ready for migrate
          </button>
          <button mat-menu-item type="button" (click)="runAction('populateSkills')">Populate skills</button>
          <button mat-menu-item type="button" (click)="runAction('populateResources')">Populate resources</button>
          <button mat-menu-item type="button" (click)="runAction('rebalanceTaxonomy')">Rebalance taxonomy</button>
          <button mat-menu-item type="button" (click)="runAction('refreshAspects')">Refresh aspects</button>
        </mat-menu>
      </div>
    </header>
  </mat-card>

  <mat-card class="section-card">
    <h2>Allowed accounts</h2>
    <mat-chip-set class="account-chips">
      <mat-chip *ngFor="let account of accountNames(role.effectiveAllowedAccounts)" [matTooltip]="account.slug">
        {{ account.name }}
      </mat-chip>
      <mat-chip *ngIf="!accountNames(role.effectiveAllowedAccounts).length">None</mat-chip>
    </mat-chip-set>
    <mat-form-field appearance="outline" class="account-select">
      <mat-label>Accounts with this role</mat-label>
      <mat-select [(ngModel)]="roleAccountDraft" [ngModelOptions]="{standalone: true}" multiple>
        <mat-option *ngFor="let account of accountOptions" [value]="account.id">
          {{ account.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-flat-button type="button" color="primary" (click)="saveRoleAccounts()" [disabled]="isBusy">
      Save role accounts
    </button>
  </mat-card>

  <mat-card class="section-card" *ngIf="listItem">
    <h2>Seniority learner visibility</h2>
    <div *ngFor="let core of listItem.coreBySeniority" class="seniority-row">
      <span><strong>{{ core.seniority }}</strong> (core) — {{ core.totalCoreSkills }} skills</span>
      <mat-slide-toggle
        *ngIf="core.hasSeniorityLevelRecord !== false"
        [checked]="core.seniorityIsActive !== false"
        [disabled]="loading"
        (change)="onSeniorityActivation({ roleSlug: slug, seniority: core.seniority, active: $event.checked })">
      </mat-slide-toggle>
    </div>
    <div *ngFor="let spec of listItem.specializationBySeniority" class="seniority-row">
      <span><strong>{{ spec.specializationName }}</strong> / {{ spec.seniority }}</span>
      <mat-slide-toggle
        *ngIf="spec.hasSeniorityLevelRecord !== false"
        [checked]="spec.seniorityIsActive !== false"
        [disabled]="loading"
        (change)="onSeniorityActivation({ roleSlug: slug, seniority: spec.seniority, active: $event.checked })">
      </mat-slide-toggle>
    </div>
  </mat-card>

  <mat-card class="section-card">
    <h2>Specializations</h2>
    <div class="spec-row" *ngFor="let spec of role.specializations">
      <div class="spec-main">
        <div>
          <strong>{{ spec.name }}</strong>
          <span class="meta">{{ spec.slug }}</span>
          <mat-chip-set class="status-chips">
            <mat-chip>Status: {{ specStatusLabel(spec) }}</mat-chip>
          </mat-chip-set>
        </div>
        <p class="inherit-hint" *ngIf="spec.inheritsRoleAccounts">Inherits role accounts</p>
        <mat-chip-set class="account-chips">
          <mat-chip *ngFor="let account of accountNames(spec.effectiveAllowedAccounts)" [matTooltip]="account.slug">
            {{ account.name }}
          </mat-chip>
          <mat-chip *ngIf="!accountNames(spec.effectiveAllowedAccounts).length">None</mat-chip>
        </mat-chip-set>
        <div class="spec-account-edit" *ngIf="isCustomizingSpec(spec.slug); else customizeBtn">
          <mat-form-field appearance="outline" class="account-select">
            <mat-label>Accounts for {{ spec.name }}</mat-label>
            <mat-select
              [(ngModel)]="specAccountDrafts[spec.slug]"
              [ngModelOptions]="{standalone: true}"
              multiple>
              <mat-option *ngFor="let account of accountOptions" [value]="account.id">
                {{ account.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="spec-account-actions">
            <button mat-flat-button type="button" color="primary" (click)="saveSpecAccounts(spec.slug)" [disabled]="isBusy">
              Save
            </button>
            <button mat-stroked-button type="button" (click)="resetSpecInherit(spec.slug)" [disabled]="isBusy">
              Reset to inherit
            </button>
          </div>
        </div>
        <ng-template #customizeBtn>
          <button mat-stroked-button type="button" (click)="startCustomizeSpec(spec)" [disabled]="isBusy">
            Customize accounts
          </button>
        </ng-template>
      </div>
      <div class="spec-actions">
        <button
          mat-stroked-button
          type="button"
          *ngIf="!isSpecEngaged(spec)"
          (click)="setSpecActivation(spec.slug, true)"
          [disabled]="isBusy">
          Activate
        </button>
        <button
          mat-stroked-button
          type="button"
          *ngIf="isSpecEngaged(spec) && !isSpecMigratable(spec)"
          (click)="setSpecActivation(spec.slug, true, true)"
          [disabled]="isBusy">
          Ready for migrate
        </button>
        <button
          mat-stroked-button
          type="button"
          *ngIf="isSpecEngaged(spec)"
          (click)="setSpecActivation(spec.slug, false)"
          [disabled]="isBusy">
          Deactivate
        </button>
        <button
          mat-stroked-button
          type="button"
          color="warn"
          (click)="removeSpecialization(spec)"
          [disabled]="isBusy">
          Remove
        </button>
      </div>
    </div>
  </mat-card>

  <mat-card class="section-card">
    <h2>Add specialization</h2>
    <form [formGroup]="specForm" class="spec-form">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Slug (optional)</mat-label>
        <input matInput formControlName="slug" />
      </mat-form-field>
      <button mat-flat-button type="button" (click)="addSpecialization()" [disabled]="specForm.invalid || loading">Add</button>
    </form>
  </mat-card>
</ng-container>